import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output } from '@angular/core';

import { InventoryItemDto } from '../../api/inventoryItemDto';
import { NarwhalService } from '../../narwhal.service';

@Component({
  selector: 'narwhalia-my-swarm-inventory',
  templateUrl: './my-swarm-inventory.component.html',
  styleUrls: ['./my-swarm-inventory.component.scss'],
  // tslint:disable-next-line:use-host-property-decorator
  host: {
    '[class.isOverflowing]': 'isOverflowing'
  }
})
export class MySwarmInventoryComponent implements OnInit {
  @Output() emitVisibility: EventEmitter<any>;
  inventory: InventoryItemDto[];
  isOverflowing: boolean;

  @HostListener('document:click', ['$event'])
  clickedOutside(event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.emitVisibility.emit();
    }
  }

  @HostListener('window:resize', ['$event'])
  onresize() {
    setTimeout(() =>
      this.calculateOverflow()
      , 20);
  }

  constructor(private narwhalService: NarwhalService, private elementRef: ElementRef) {
    this.emitVisibility = new EventEmitter();
    this.narwhalService.inventoryItems$.subscribe(inventoryItems => (this.inventory = inventoryItems));
  }

  closePopup() {
    this.emitVisibility.emit();
  }

  ngOnInit() {
    setTimeout(() =>
      this.calculateOverflow()
      , 0);
  }

  private calculateOverflow() {
    const element = this.elementRef.nativeElement;
    const windowHeight = document.documentElement.clientHeight;
    const fullHeight = element.offsetTop + element.clientHeight;
    if (windowHeight < fullHeight) {
      this.isOverflowing = true;
      element.style.height = windowHeight - element.offsetTop + 'px';
    } else {
      this.isOverflowing = false;
      element.style.height = 'auto';

    }
  }
}